import { Box, IconButton } from '@material-ui/core'
import { ReceiptSharp, RemoveRedEye, VerifiedSharp } from '@mui/icons-material'
import CheckIcon from '@mui/icons-material/Check'
import LinkIcon from '@mui/icons-material/Link'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import { useNavigate } from 'react-router'
const bgRoles = [
  {
    role: 'Owner',
    bg: 'orange',
  },
  {
    role: 'Delegator',
    bg: '#1976d2',
  },
]
const colors = [
  '#2e7d32', // 0 green
  'orange', // 1
  '#d32f2f', // 2 red
  '#1976d2', // 3 blue
  '#ced4da', // 4 gray
]
export const handleLRAR = (row, ag_id, translate, getPreviewFile) => {
  // sent - gray  / error - red / received - green
  const lrar = row.lrar
  if (!lrar) {
    return null
  }
  let error = false
  let color = colors[3]
  if (lrar.status === 'sent') {
    color = colors[4]
  }
  if (lrar.status === 'wrong_address') {
    color = colors[2]
  }
  if (lrar.status === 'distributed') {
    color = colors[0]
  }
  if (lrar.status === 'error') {
    color = colors[2]
    error = lrar.error
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          fontSize: 12,
        }}
      >
        <span
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(lrar?.file)
          }}
          style={{ cursor: 'pointer' }}
        >
          <RemoveRedEye style={{ color: color, marginRight: 5 }} />
        </span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(lrar?.proof)
          }}
        >
          {lrar.proof ? (
            <VerifiedSharp style={{ color: colors[0] }} />
          ) : (
            <>&nbsp;</>
          )}
        </span>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}
      >
        <span>
          {error
            ? error
            : lrar?.status
            ? translate(`hs.convocation.${lrar?.status}`, { _: lrar?.status })
            : ''}
        </span>
      </Box>
      {/* // if diff empty property proof return icon workspacepremium */}
    </Box>
  )
}
export const handleDigital = (
  convocation,
  ag_id,
  navigate,
  translate,
  getPreviewFile
) => {
  const digital = convocation.digital
  if (!digital) {
    return null
  }
  let color = colors[4]
  let signed = false
  if (digital.status === 'sent') {
    color = colors[4]
  }
  if (digital.status === 'signed') {
    color = colors[0]
    signed = true
  }
  if (digital.status === 'signer_viewed') {
    color = colors[1]
  }
  if (digital.status === 'declined') {
    color = colors[2]
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          fontSize: 12,
        }}
      >
        <span
          onClick={(e) => {
            getPreviewFile(digital.file)
          }}
          style={{ cursor: 'pointer' }}
        >
          <RemoveRedEye style={{ color: color, marginRight: 5 }} />
        </span>
        <span
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault()
            getPreviewFile(digital.proof)
          }}
        >
          {digital.proof ? (
            <VerifiedSharp style={{ color: colors[0] }} />
          ) : (
            <>&nbsp;</>
          )}
        </span>
      </Box>
      <Box
        sx={{
          fontSize: 12,
        }}
      >
        <span>
          {digital.status
            ? translate(`hs.convocation.${digital.status}`, {
                _: digital.status,
              })
            : ''}
        </span>
      </Box>
    </Box>
  )
}
export const handleContact = (contact, translate) => {
  let name = [contact.firstname, contact.lastname].filter(Boolean).join(' ')
  let line3 = [
    contact.adresse.postalCode,
    contact.adresse.city,
    contact.adresse.country,
  ]
    .filter(Boolean)
    .join(' ')
  let address = [contact.adresse.line1, contact.adresse.line2, line3]
    .filter(Boolean)
    .join(' ')
  return (
    <>
      {name} {handleRoles(contact.roles, translate)} {name && <br />}
      {address}
      {address && <br />}
      {contact.email}
      {contact.email && <br />}
    </>
  )
}
export const handleCoproprietaire = (row) => {
  return row?.coowner?.name
}
export const handleStatus = (status) => {
  // null / error / done / pending
  let color = null
  if (status === 'done') {
    color = colors[0]
  }
  if (status === 'error') {
    color = colors[2]
  }
  if (status === 'pending') {
    color = colors[1]
  }
  return color ? <CheckIcon style={{ color: color }} /> : null
}
export const handleRoles = (row, translate) => {
  const roles = row.contact.roles
  return (
    <>
      {roles.map((role) => {
        return (
          <span
            style={{
              background:
                bgRoles.find((item) => item.role == role)?.bg || 'grey',
              color: 'white',
              marginRight: 5,
              padding: 3,
              borderRadius: '5px',
            }}
          >
            {role ? translate(`hs.convocation.${role}`, { _: role }) : ''}
          </span>
        )
      })}
    </>
  )
}
